import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Button } from '../../Zemplin/General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { ButtonWithRequest } from './ButtonWithRequest';
import { TableTd } from '../../Zemplin/General/Table';
import { CountSetter } from './CountSetter';
import { useState } from 'react';
import { Watching } from './Watching';

interface Props {
  price: string;
  isSale: number;
  oldPrice: string;
  salePercentage: string;
  addToRequest: any;
  addToCart: any;
  avail_id: number;
  unit: string;
}

function ProductPriceCartTable({
  price,
  addToCart,
  addToRequest,
  avail_id,
  isSale,
  oldPrice,
  salePercentage,
}: Props) {
  const [count, setCount] = useState(1);
  const handleCountChange = newValue => {
    setCount(newValue);
  };
  return (
    <>
      {!avail_id || avail_id === 11 ? (
        <>
          <PriceTableTd align={'right'}>
            <Soon>{`UŽ ČOSKORO`}</Soon>
          </PriceTableTd>
          <ButtonTableTd colSpan={2}>
            <Watching />
          </ButtonTableTd>
        </>
      ) : (
        <>
          <PriceTableTd align={'right'}>
            {isSale === 1 && (
              <OldPrice>{`${oldPrice} € (-${salePercentage}%)`}</OldPrice>
            )}
            {`${price} €`}
          </PriceTableTd>
          <CountSetterTd>
            <CountSetter count={count} onChange={handleCountChange} />
          </CountSetterTd>
          <ButtonTableTd>
            <ButtonWithRequest
              onButtonClick={addToCart}
              onRequestClick={addToRequest}
              avail_id={avail_id}
              hasDropdown={true}
            />
          </ButtonTableTd>
        </>
      )}
    </>
  );
}

const PriceTableTd = styled(TableTd)`
  padding: ${rem(16)};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(20)};
  font-weight: 500;
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(6)};
  white-space: nowrap;
`;

const ButtonTableTd = styled(TableTd)`
  padding: ${rem(16)} ${rem(16)} ${rem(16)} 0;
`;

const CountSetterTd = styled(TableTd)`
  width: ${rem(120)};
`;

const OldPrice = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.stockCountSold};
  letter-spacing: 0;

  ${({ theme }) => theme.mediab.l1050`
    display: none;
  `}
`;

const Soon = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 500;
  color: #cccccc;
`;

export { ProductPriceCartTable };
